import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useStore from "@/store";
import { useFetchWorkspaceById } from "@/hooks/useFetchWorkspaceById";
import LoadingScreen from "@/components/LoadingScreen";

export function WorkpaceIdWorkflowIdRedirect() {
    const { workspaceId, workflowId } = useParams<{ workspaceId: string; workflowId: string }>();
    const navigate = useNavigate();

    const { data: workspace, error: workspaceError } = useFetchWorkspaceById(workspaceId);

    const fetchWorkflowById = useStore((state) => state.fetchWorkflowById);
    const currentWorkflow = useStore((state) => state.getCurrentWorkflow());
    const workflowError = useStore((state) => state.workflowError);

    useEffect(() => {
        if (workflowId && (!currentWorkflow || currentWorkflow.id !== workflowId)) {
            fetchWorkflowById(workflowId);
        }
    }, [workflowId, fetchWorkflowById, currentWorkflow]);

    useEffect(() => {
        if (workspace && currentWorkflow && currentWorkflow.id === workflowId) {
            navigate(`/${workspace.url}/${currentWorkflow.url}/deploy`, { replace: true });
        }
    }, [workspace, navigate, currentWorkflow, workflowId]);

    useEffect(() => {
        if (workspaceError || workflowError) {
            // eslint-disable-next-line no-console
            console.error(
                "🐞[DEBUG - WorkpaceIdWorkflowIdRedirect] error",
                workspaceError,
                workflowError
            );
            navigate("/");
        }
    }, [workspaceError, workflowError, navigate]);

    return <LoadingScreen />;
}
